import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import fr from "./locales/fr.json";

// This block of code triggers a HOOK warning !!!!

let preferredLanguageCode = localStorage.getItem("prefLanguage");


const resources = {
  fr,
  en,
};

i18n.use(initReactI18next).init({
  resources,
  lng: preferredLanguageCode,
  fallbackLng: preferredLanguageCode,
  interpolation: {
    escapeValue: false,
  },
  debug: false,
});

export default i18n;
